// 🔧 report_summary.js
// ✅ Purpose: Creates a concise Demo Engine execution summary
// ✅ Features:
// - Summarizes created objects
// - Calculates total created records
// - Future-ready for timing and performance metrics
// - Fully block-commented for clarity and future devs

export const buildReportSummary = ({
  report,
} = {}) => {
  const created = report?.created || {};

  const totalCreated =
    (created.categories || 0) +
    (created.entries || 0) +
    (created.users || 0) +
    (created.votes || 0);

  return {
    totalCreated,

    categories: created.categories || 0,

    entries: created.entries || 0,

    users: created.users || 0,

    votes: created.votes || 0,
  };
};